
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Single-Neutral-Id-Card-3--Streamline-Streamline--3.0.svg","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","height":"24","width":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('desc',[_v('Single Neutral Id Card 3 Streamline Icon: https://streamlinehq.com')]),_c('defs'),_c('title',[_v('single-neutral-id-card-3')]),_c('path',{attrs:{"d":"M9.75 5.25h-7.5a1.5 1.5 0 0 0 -1.5 1.5v13.5a1.5 1.5 0 0 0 1.5 1.5h19.5a1.5 1.5 0 0 0 1.5 -1.5V6.75a1.5 1.5 0 0 0 -1.5 -1.5h-7.5","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M14.25 4.5a2.25 2.25 0 0 0 -4.5 0v3a0.75 0.75 0 0 0 0.75 0.75h3a0.75 0.75 0 0 0 0.75 -0.75Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M5.625 13.875a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 1 0 -5.25 0","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M3.75 21.75a4.5 4.5 0 0 1 9 0Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m14.25 12.75 4.5 0","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m14.25 15.75 6 0","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    